import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a31b988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attention-title" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-size-14 ml-2" }, "注意事項", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-size-12 attention-text" }, "\n      招待された方が資格認証から1ヶ月以内に勤務完了した場合に限り、ポイント付与対象となります\n    ", -1))

import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferAttention',
  props: {
  isGrayOut: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["attention-section my-4", { 'gray-out': __props.isGrayOut }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FeatherIcon, {
          size: "20",
          icon: "alert-triangle"
        }),
        _createTextVNode(),
        _hoisted_3
      ])
    ]),
    _createTextVNode(),
    _hoisted_4
  ], 2))
}
}

})